import './App.css';
import WeatherDisplay from './components/WeatherDisplay';
function App() {
  return (

    <div>
      < WeatherDisplay/>

    </div>

  )
}
export default App;
